module.exports = __webpack_public_path__ + "img/paginate_arrow.5e466c53.svg";